import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Button, ButtonContainer, Icon } from '@emburse/embark-core';
import { FileDownloadIcon } from '@emburse/embark-icons';
import { FileUploadButton } from '../../../../components';
import { $t, useTranslation } from '../../../../hooks/useTranslation';
function UploadDownload({ upload, download }) {
    useTranslation();
    return (_jsxs(ButtonContainer, { alignButtons: "right", children: [_jsx(Button, { variant: "outlined", size: "small", onClick: download, startIcon: _jsx(Icon, { iconUrl: FileDownloadIcon }), children: $t('Download Template') }), _jsx(FileUploadButton, { accept: ".xlsx", onFileSelect: upload, size: "small", children: $t('Upload Your Data') })] }));
}
export default UploadDownload;
